import apiClient from './client';

export interface Personnel {
  id: string;
  firstName: string;
  lastName: string;
  department: string;
  company?: string;
  phone?: string;
  email?: string;
  address?: string;
  photo?: string;
  branch: string;
  isActive: boolean;
  deviceCount?: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePersonnelRequest {
  firstName: string;
  lastName: string;
  department: string;
  company?: string;
  branch?: string;
  phone?: string;
  email?: string;
  address?: string;
  photo?: string;
}

export interface UpdatePersonnelRequest {
  firstName?: string;
  lastName?: string;
  department?: string;
  company?: string;
  branch?: string;
  phone?: string;
  email?: string;
  address?: string;
  photo?: string;
  isActive?: boolean;
}

export const personnelApi = {
  getAll: async (search?: string, departmentId?: string, companyId?: string): Promise<Personnel[]> => {
    const params: any = {};
    if (search) params.search = search;
    if (departmentId) params.departmentId = departmentId;
    if (companyId) params.companyId = companyId;
    
    const response = await apiClient.get('/personnel', { params });
    return response.data.map((item: any) => ({
      ...item,
      id: item._id,
      deviceCount: item.deviceCount || 0,
      // Keep populated objects as is, only convert if they're strings
      department: typeof item.department === 'string' ? item.department : item.department,
      company: typeof item.company === 'string' ? item.company : item.company,
      branch: typeof item.branch === 'string' ? item.branch : item.branch,
    }));
  },

  getById: async (id: string): Promise<Personnel> => {
    const response = await apiClient.get(`/personnel/${id}`);
    return {
      ...response.data,
      id: response.data._id,
      // Keep populated objects as is
      department: response.data.department,
      company: response.data.company,
      branch: response.data.branch,
    };
  },

  create: async (data: CreatePersonnelRequest): Promise<Personnel> => {
    const response = await apiClient.post('/personnel', data);
    return {
      ...response.data,
      id: response.data._id,
      // Keep populated objects as is
      department: response.data.department,
      company: response.data.company,
      branch: response.data.branch,
    };
  },

  update: async (id: string, data: UpdatePersonnelRequest): Promise<Personnel> => {
    const response = await apiClient.put(`/personnel/${id}`, data);
    return {
      ...response.data,
      id: response.data._id,
      // Keep populated objects as is
      department: response.data.department,
      company: response.data.company,
      branch: response.data.branch,
    };
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/personnel/${id}`);
  },

  getPersonnelDevices: async (id: string): Promise<any> => {
    const response = await apiClient.get(`/personnel/${id}/devices`);
    return response.data;
  },
};
